import request from "./request";
import url from "./url";

export default {
  refreshToken: (refreshToken) =>
    request({
      method: "post",
      url: url.authRefreshToken,
      data: { refresh_token: refreshToken },
    }),
  profile: () =>
    request({
      url: url.authProfile,
    }),
  getUser: (id) =>
    request({
      url: url.authUser.replace(":id", id),
    }),
  getLEDList: (params) =>
    request({
      url: url.led,
      params,
    }),
  addLED: (data) =>
    request({
      method: "post",
      url: url.led,
      data,
    }),
  getLED: (id) =>
    request({
      url: url.ledX.replace(":id", id),
    }),
  editLED: (data) =>
    request({
      method: "patch",
      url: url.ledX.replace(":id", data.id),
      data,
    }),
  deleteLED: (id) =>
    request({
      method: "delete",
      url: url.ledX.replace(":id", id),
    }),
  getLEDLike: (params) =>
    request({
      url: url.likedLED,
      params,
    }),
  checkLEDLike: (ids) =>
    request({
      method: "post",
      url: url.checkLEDLike,
      data: { led_ids: ids },
    }),
  likeLED: (id) =>
    request({
      method: "post",
      url: url.likeLED,
      data: { led_id: id },
    }),
  unlikeLED: (id) =>
    request({
      method: "post",
      url: url.unlikeLED,
      data: { led_id: id },
    }),
  addComment: (data) =>
    request({
      method: "post",
      url: url.comment,
      data,
    }),
  getCommentList: (params) =>
    request({
      url: url.comment,
      params,
    }),
  getCommentCount: (ids) =>
    request({
      url: url.commentCount,
      params: { content_type: "diy_led", object_ids: ids },
    }),
  getLEDDraftList: (params) =>
    request({
      url: url.ledDraft,
      params,
    }),
  getLoaderList: (platform) =>
    request({
      url: url.historyVersion,
      params: {
        app_code: "AM_Master",
        platform,
      },
    }),
  chat: (data) =>
    request({
      method: "post",
      url: url.chat,
      data,
      headers: {
        Authorization: "Bearer iFVXoa27z4GnyWKmhcuOLTe4qzj8k96bSSb5QIlL",
      },
    }),
};

export { default as url } from "./url";
